import { type IconProps } from './Icon.types';

const LinkedInIcon: React.FC<IconProps> = ({
  className,
  fill = 'currentColor',
  width,
  height,
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0ZM7.20103 12.4236H10.6004V22.6372H7.20103V12.4236ZM10.8242 9.26419C10.8022 8.26275 10.0861 7.5 8.92316 7.5C7.76027 7.5 7.00002 8.26275 7.00002 9.26419C7.00002 10.2449 7.7378 11.0296 8.87904 11.0296H8.90076C10.0861 11.0296 10.8242 10.2449 10.8242 9.26419ZM18.9457 12.1838C21.1827 12.1838 22.8596 13.6439 22.8596 16.7811L22.8595 22.6372H19.4603V17.173C19.4603 15.8004 18.9684 14.8639 17.7378 14.8639C16.7987 14.8639 16.2393 15.4953 15.9936 16.1051C15.9038 16.3236 15.8817 16.6281 15.8817 16.9334V22.6375H12.482C12.482 22.6375 12.5268 13.3823 12.482 12.4239H15.8817V13.8706C16.3329 13.1751 17.1409 12.1838 18.9457 12.1838Z" fill={fill}/>
  </svg>
);

export default LinkedInIcon;